<template>
    <div>
        <el-dialog title="修改题目" width="1400px" class="icon-dialog" :visible.sync="show" @open="open"
            :before-close="closeForm" append-to-body>
            <el-form :size="size" :inline="true" :model="form">
                <el-row>
                        <el-form-item label="题目类型：">
                        <el-select  @change="changetype"  style="width: 100px;" size="small" v-model="form.type" placeholder="请选择">
                            <el-option v-for="type in type" :label="type.key" :value="type.value"
                                :key="type.value"></el-option>
                        </el-select>
                       </el-form-item>
                        <el-form-item label="科目类别：">
                        <el-select @change="changesubject" style="width: 100px;" size="small" v-model="form.subject" placeholder="请选择">
                            <el-option v-for="type in subject" :label="type.key" :value="type.value"
                                :key="type.value"></el-option>
                        </el-select>
                    </el-form-item>
                        <el-form-item label="题型：" >
                         <el-select style="width: 100px;" size="small" v-model="form.type_question" placeholder="请选择">
                         <el-option v-for="type in type_question" :label="type.key" :value="type.value" :key="type.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="题目分类：">
                        <el-checkbox-group v-model="form.classify">
                        <el-checkbox-button style="margin: 4px;"  v-for="(item,index) in cities" :label="item.pcid" :key="item.pcid">{{item.classify}}</el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>
                </el-row>
            </el-form>
            <el-form :size="size" ref="form" :model="form" :rules="rules"
                :label-width="$store.getters.device !== 'mobile' ? '16%' : '90px'">
               
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="题目：" prop="title">
                            <el-input autoComplete="off" v-model="form.title" clearable placeholder="请输入题目" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="选项A：" prop="opt1">
                            <el-input autoComplete="off" v-model="form.opt1" clearable placeholder="请输入选项A" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="选项B：" prop="opt2">
                            <el-input autoComplete="off" v-model="form.opt2" clearable placeholder="请输入选项B" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="选项C：" prop="opt3">
                            <el-input autoComplete="off" v-model="form.opt3" clearable placeholder="请输入选项C" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="选项D：" prop="opt4">
                            <el-input autoComplete="off" v-model="form.opt4" clearable placeholder="请输入选项D" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="答案：" prop="opt4">
                            <el-input autoComplete="off" v-model="form.answer" clearable placeholder=" 输入ABCD 每个选项用|隔开" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <div style="display: flex;justify-content: space-around;">
                    <div>
                    <div style="display: flex;justify-content: space-between;align-items: center;">
                        <div>点击修改图片</div>
                    <el-button size="small"  type="primary" @click="deleteimg()">删除图片</el-button>
                    </div>
                    <div class="flexs">
                        <el-upload
                            class="avatar-uploader"
							     :headers="headers"
                            :action="updatehttp" 
                            accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP"  
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload"
                        >
                            <el-image v-if="form.title_img"  class="avatar"
                            :src="form.title_img" ></el-image>
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>

                    </div>
                </div>

                <div >
                    <div style="display: flex;justify-content: space-between;align-items: center;">
                        <div>修改技巧讲解图片</div>
                    <el-button size="small"  type="primary" @click="jqimg()">删除讲解图片</el-button>
                    </div>
                    <div class="flexs">
                        <el-upload
							:headers="headers"
                            class="avatar-uploader"
                            :action="updatehttp" 
                            accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP"  
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess1"
                            :before-upload="beforeAvatarUpload"
                        >
                            <el-image v-if="form.explain_skill_gif"  class="avatar"
                            :src="form.explain_skill_gif" ></el-image>
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :size="size" :loading="loading" type="primary" @click="submit">
                    <span v-if="!loading">确 定</span>
                    <span v-else>提 交 中...</span>
                </el-button>
                <el-button :size="size" @click="closeForm">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getedit,getclassify } from '../../api/userMG';

export default {
    name: 'bannerupdate',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'small'
        },
        info: {
            type: Object,
        },
    },
    data() {
        return {
            updatehttp:'/problem/getImg',
            headers: {
            token: localStorage.getItem('logintoken')
            },
            cities:[],
            subject: [
                { key: '科目一', value: 0 },
                { key: '科目四', value: 3 },
            ],
            type: [
                { key: '小车', value: 0 },
                { key: '货车', value: 1 },
                { key: '客车', value: 2 },
                { key: '摩托车', value: 3 },
            ],
            type_question: [
                { key: '判断', value: 0 },
                { key: '单选', value: 1 },
                { key: '多选', value: 2 },
            ],
            form: {
               
            },
            loading: false,
            rules: {
            },
            files:'',
        }
    },
    methods: {
        deleteimg(){
            this.form.title_img = ''
        },
        jqimg(){
            this.form.explain_skill_gif = ''
        },
        		//题目类型改变
		changetype(e){
            this.form.classify = []

			this.rules.type = e
			this.getf()
		},
				//题目类型改变
		changesubject(e){
            this.form.classify = []

			this.rules.subject = e
			this.getf()
		},
        handleAvatarSuccess(res, file) {
            console.log(res,'成功失败');
            this.form.title_img = res.img_url
         },
            beforeAvatarUpload(file) {
                // const isJPG = file.type === 'image/jpeg';
                // const isLt2M = file.size / 1024 / 1024 < 2;

                // if (!isJPG) {
                // this.$message.error('上传头像图片只能是 JPG 格式!');
                // }
                // if (!isLt2M) {
                // this.$message.error('上传头像图片大小不能超过 2MB!');
                // }
                // return isJPG && isLt2M;
            },
        handleAvatarSuccess1(res, file) {
            console.log(res,'成功失败');
            this.form.explain_skill_gif = res.img_url
         },
        open() {
            this.form = this.info
            this.rules.pbid = this.form.pbid
            this.rules.type = this.info.type
            this.rules.subject = this.info.subject 
            this.getf()
        },
        getf(){
            getclassify(this.rules).then(res=>{
                this.cities = res.classify
            }) 
        },
        submit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.loading = true
                    console.log(this.form);
                    this.form.echo = 'set'
                    getedit(this.form).then(res => {
                        if (res.code == 200) {
                            this.$message({ message: '操作成功', type: 'success' })
                            this.$emit('refesh_list')
                            this.closeForm()
                        }else{
                            this.$message({ message: res.msg, type: 'error' })
                        }
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        },
        closeForm() {
            this.$emit('update:show', false)
            this.loading = false
            if (this.$refs['form'] !== undefined) {
                this.$refs['form'].resetFields()
            }
        },
    }
}
</script>
<style scoped >
.flexs{
    display: flex;
    width: 500px;
    justify-content: space-between;
    margin-top: 20px;
}

.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed red;

  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 280px;
    height: 168px;
    display: block;
    border: 1px solid #8c939d;
  }
</style>



// WEBPACK FOOTER //
// src/views/topic/uptext.vue